<template>
    <div class="legendClass">
        <div v-for="detail in details" :key="detail.label" class="legend-detail d-flex align-center mb-1 mr-2">
            <!-- BOX CON ICONA -->
            <div v-if="detail.icon && detail.color" class="legend-icon-box mr-2 d-flex align-center justify-center"
                :style="{ backgroundColor: detail.color }">
                <v-icon small :color="detail.iconColor || '#000'">
                    {{ detail.icon }}
                </v-icon>
            </div>
            <div v-else-if="detail.color && detail.shape === 'diamond'" class="legend-box diamond-shape mr-2"
                :style="{ backgroundColor: detail.color }" />
            <div v-else-if="detail.text" class="legend-text-no-border mr-2">
                {{ detail.text }}
            </div>
            <div v-else-if="detail.special === 'diagonal-stripe'" class="legend-box diagonal-stripe mr-2"
                :style="{ backgroundColor: detail.color }" />
            <div v-else-if="detail.special === 'top-line'" class="legend-box top-line mr-2"
                :style="{ backgroundColor: detail.color }" />
            <div v-else-if="detail.special === 'bottom-black-line'" class="legend-box bottom-black-line mr-2"
                :style="{ backgroundColor: detail.color }" />
            <div v-else-if="detail.special === 'bottom-red-line'" class="legend-box bottom-red-line mr-2"
                :style="{ backgroundColor: detail.color }" />
            <div v-else-if="detail.color" class="legend-box mr-2" :style="{
                backgroundColor: detail.color,
                border: detail.border ? detail.border + ' solid ' + (detail.borderColor || '#000') : 'none'
            }" />
            <span class="text-caption font-weight-regular">
                {{ detail.label }}
            </span>
        </div>
    </div>
</template>


<script>
export default {
    name: "calLegend",
    props: {
        details: {
            type: Object,
            required: true
        }
    }
};
</script>

<style scoped>
.legendClass {
    display: flex;
    flex-direction: column;
    padding: 4px;
}

.legend-detail {
    display: flex;
    align-items: center;
}

.legend-box {
    width: 16px;
    height: 16px;
    border-radius: 2px;
}

.legend-icon-box {
    width: 16px;
    height: 16px;
    border-radius: 2px;
}

.legend-text-no-border {
    width: 16px;
    height: 16px;
    font-size: 11px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
}

.diamond-shape {
    transform: rotate(45deg);
}

.diagonal-stripe {
    position: relative;
}

.diagonal-stripe::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 130%;
    height: 2px;
    background: black;
    transform: rotate(320deg);
    transform-origin: right top;
}

.top-line {
    position: relative;
}

.top-line::before {
    content: "";
    position: absolute;
    top: 1px;
    left: 0;
    width: 100%;
    height: 3px;
    background: black;
}

.bottom-black-line {
    position: relative;
}

.bottom-black-line::after {
    content: "";
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 100%;
    height: 2px;
    background: #000;
}

.bottom-red-line {
    position: relative;
}

.bottom-red-line::after {
    content: "";
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 100%;
    height: 2px;
    background: #D32F2F;
}
</style>